<template>
  <v-dialog max-width="1000" :value="value" @input="close">
    <v-toolbar>
      <v-toolbar-title>Neue Bestellung hinzufügen</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text>
        <v-form ref="form" @submit.prevent="submitForm">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-subheader>Kundendaten</v-subheader>

                <v-text-field label="Vor- und Nachname" v-model.trim="customerName" :rules="[rules.required]" />
                <v-text-field label="Firma" v-model.trim="company" />
                <v-text-field label="Straße" v-model.trim="street" :rules="[rules.required]" />
                <v-text-field label="PLZ und Ort" v-model.trim="town" :rules="[rules.required, rules.zipAndTown]" />
                <v-text-field label="Telefonnummer" v-model.trim="phone" :rules="[rules.required]" />
                <v-text-field label="E-Mail-Adresse" v-model.trim="email" :rules="[rules.email]" />

                <v-divider></v-divider>

                <v-text-field label="Alternative Lieferadresse" v-model.trim="alternative_1" />
                <v-text-field label="Handynummer, Kleingarten" v-model.trim="alternative_2" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-subheader>Produkte</v-subheader>

                <v-checkbox
                  v-model="spread"
                  label="Rasendünger ausstreuen"
                ></v-checkbox>

                <v-text-field
                  v-for="product in products"
                  :key="product.id"
                  outlined
                  dense
                  persistent-hint
                  type="number"
                  placeholder="Anzahl"
                  v-model.number="productsSelection[product.id]"
                  :label="product.name + ' ' + $options.filters.ff(product.weight) + 'kg'"
                />

                <v-dialog
                  ref="dialog"
                  v-model="dialog"
                  :return-value.sync="createdAt"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="createdAt"
                      label="Bestellt am"
                      readonly
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="createdAt" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog = false">Abbrechen</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(createdAt)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>

                <v-btn
                  type="submit"
                  color="primary"
                  class="mx-auto d-block"
                  :loading="loading"
                >Hinzufügen</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value"],
  async created() {
    try {
      const { data } = await this.$http.get("/product/");
      this.products = data;
    } catch (e) {
      alert("Fehler beim Laden der Produkte: " + e.message);
    }
  },
  computed: {
    filteredProductsSelection() {
      return Object.keys(this.productsSelection).reduce((prev, curr) => {
        if (this.productsSelection[curr] && this.productsSelection[curr] > 0) {
          prev[curr] = this.productsSelection[curr];
        }

        return prev;
      }, {});
    },
    selectedProducts() {
      const products = [];

      for (const id in this.productsSelection) {
        if (this.productsSelection[id] > 0)
          products.push(this.products.find(p => p.id == id));
      }

      return products;
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
    products: [],
    productsSelection: {},
    customerName: "",
    company: "",
    street: "",
    town: "",
    phone: "",
    email: "",
    alternative_1: "",
    alternative_2: "",
    createdAt: new Date().toISOString().substr(0, 10),
    spread: false,
    rules: {
      required: v => !!v || "Dieses Feld wird benötigt.",
      email: v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return v == null || (typeof v === 'string' && v.length == 0) || pattern.test(v) || "Ungültige E-Mail-Adresse.";
      },
      zipAndTown: v => {
        const pattern = /^[0-9]{5}\s.+/;
        return (
          (v && pattern.test(v.trimRight())) ||
          "Bitte richtiges Format beibehalten (erst PLZ, dann Ort)"
        );
      }
    }
  }),
  methods: {
    close() {
      this.$emit("input", false);
    },
    openWith(order) {
      this.customerName = order ? order.customer_name : null
      this.company = order ? order.company : null
      this.street = order ? order.street : null
      this.town = order ? order.town : null
      this.phone = order ? order.phone : null
      this.email = order ? order.email : null
      this.alternative_1 = order ? order.alternative_1 : null
      this.alternative_2 = order ? order.alternative_2 : null

      this.$nextTick(() => this.$refs.form.resetValidation())
      this.$emit("input", true);
    },
    async submitForm() {
      if(!this.$refs.form.validate())
        return

      if (this.selectedProducts.length === 0) {
        alert("Bitte wählen Sie mindestens einen Artikel aus.");
        return;
      }

      this.loading = true;

      try {
        await this.$http.post("/order/manually/", {
          products: this.filteredProductsSelection,
          customer_name: this.customerName,
          company: this.company,
          street: this.street,
          town: this.town,
          phone: this.phone,
          email: this.email || null,
          alternative_1: this.alternative_1,
          alternative_2: this.alternative_2,
          created_at: this.createdAt,
          spread: this.spread
        });

        // Reset
        this.$refs.form.reset()
        this.$nextTick(() => {
          this.createdAt = new Date().toISOString().substr(0, 10)
        })
        this.productsSelection = {};

        this.$emit("added")
      } catch (e) {
        alert("Ein Fehler ist aufgetreten: " + e.message);
      }

      this.loading = false;
    }
  }
};
</script>

<style>
</style>